import React from "react";

function Badge(props) {
  const { color, label } = props;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        border: `1px solid ${color}`,
        background: `${color}50`,
        borderRadius: "50px",
        width: "fit-content",
        padding: "10px",
        marginTop: "5px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          height: "12px",
          width: "12px",
          borderRadius: "50%",
          backgroundColor: color,
          marginRight: "10px",
          fontSize: "12px",
        }}
      ></div>
      <span>{label}</span>
    </div>
  );
}

export default Badge;
